// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Preferences_preferences__Immij {
	background: var(--ui-pinkish, #fff8f6);
	width: 100vw;
	padding: 6.25rem 10.31rem;

	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 5rem;
}

.Preferences_preferences__items__EqQ9v {
	width: 100%;
	display: flex;
	justify-content: space-between;
}

.Preferences_item__rqflF {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.5rem;

	color: var(--accent-color, #956446);
	text-align: center;

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

@media (max-width: 1280px) {
	.Preferences_preferences__Immij {
		padding: 6.25rem 5rem;
	}
}

@media (max-width: 460px) {
	.Preferences_preferences__Immij {
		flex-direction: column;
		padding: 4.38rem 1.25rem;
		align-items: center;
		gap: 3.12rem;
	}

	.Preferences_about__2jo\\+v img {
		display: none;
	}
	.Preferences_text__side__rVnFX {
		width: 100%;
		align-items: center;
	}
	.Preferences_preferences__items__EqQ9v {
		flex-wrap: wrap;
		gap: 1rem;
		row-gap: 2.5rem;
	}
	.Preferences_item__rqflF {
		width: 10rem;
		font-size: 0.9375rem;
	}
}

@media (max-width: 380px) {
	.Preferences_item__rqflF {
		width: 8rem;
	}
}

@media (max-width: 320px) {
	.Preferences_item__rqflF {
		width: 6rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/Preferences/Preferences.module.css"],"names":[],"mappings":"AAAA;CACC,sCAAsC;CACtC,YAAY;CACZ,yBAAyB;;CAEzB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,aAAa;CACb,8BAA8B;AAC/B;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;;CAEX,mCAAmC;CACnC,kBAAkB;;CAElB,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;CACb;;CAEA;EACC,aAAa;CACd;CACA;EACC,WAAW;EACX,mBAAmB;CACpB;CACA;EACC,eAAe;EACf,SAAS;EACT,eAAe;CAChB;CACA;EACC,YAAY;EACZ,oBAAoB;CACrB;AACD;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,WAAW;CACZ;AACD","sourcesContent":[".preferences {\n\tbackground: var(--ui-pinkish, #fff8f6);\n\twidth: 100vw;\n\tpadding: 6.25rem 10.31rem;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 5rem;\n}\n\n.preferences__items {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: space-between;\n}\n\n.item {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tgap: 1.5rem;\n\n\tcolor: var(--accent-color, #956446);\n\ttext-align: center;\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n@media (max-width: 1280px) {\n\t.preferences {\n\t\tpadding: 6.25rem 5rem;\n\t}\n}\n\n@media (max-width: 460px) {\n\t.preferences {\n\t\tflex-direction: column;\n\t\tpadding: 4.38rem 1.25rem;\n\t\talign-items: center;\n\t\tgap: 3.12rem;\n\t}\n\n\t.about img {\n\t\tdisplay: none;\n\t}\n\t.text__side {\n\t\twidth: 100%;\n\t\talign-items: center;\n\t}\n\t.preferences__items {\n\t\tflex-wrap: wrap;\n\t\tgap: 1rem;\n\t\trow-gap: 2.5rem;\n\t}\n\t.item {\n\t\twidth: 10rem;\n\t\tfont-size: 0.9375rem;\n\t}\n}\n\n@media (max-width: 380px) {\n\t.item {\n\t\twidth: 8rem;\n\t}\n}\n\n@media (max-width: 320px) {\n\t.item {\n\t\twidth: 6rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preferences": `Preferences_preferences__Immij`,
	"preferences__items": `Preferences_preferences__items__EqQ9v`,
	"item": `Preferences_item__rqflF`,
	"about": `Preferences_about__2jo+v`,
	"text__side": `Preferences_text__side__rVnFX`
};
export default ___CSS_LOADER_EXPORT___;
